import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStatusService } from './local-status.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [LocalStatusService]
})
export class LocalStatusModule {}
